import { useMemo } from "react";
import { useOrgData } from "../../../../contexts/OrgDataContext";
import { getText, LOGS_TYPES } from "../../../../services/log/log-service";
import moment from "moment/moment";
import { ExclamationTriangleIcon, InformationCircleIcon } from "@heroicons/react/20/solid";
import Badge from "../../../../components/badges/Badge";

export const DefaultLog = ({ log }) => {

  const { type, time } = log;
  const { eventTypes } = useOrgData();

  const isAlert = type === LOGS_TYPES.ALERT;

  const circleColor = isAlert ? 'bg-perception-error-500' : 'bg-perception-black-900';
  const textColor = isAlert ? 'text-perception-error-500 font-medium' : '';


  return useMemo(() => (
    <div className="ml-8 border-l-1 border-perception-gray-600 relative flex pb-2 pr-4">

      {/* Circle */}
      <div className="absolute size-3 top-0 -left-1.5 rounded-full bg-perception-gray-500">
        <div className={`size-2 ${circleColor} absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full`}/>
      </div>

      {/* Datetime */}
      <div className="text-sm -mt-1 w-32 text-center">
        {moment(time).format('HH:mm:ss')}
      </div>

      {/* Log content */}
      <div className="flex-1 bg-perception-black-800 px-4 pr-1 py-1 rounded-md flex justify-between items-center">
        <div className="flex items-center gap-4">
          {
            isAlert ?
              <ExclamationTriangleIcon className={`size-4 min-w-4 ${textColor}`}/>
              :
              <InformationCircleIcon className={`size-4 min-w-4 ${textColor}`}/>
          }
          <div className={`text-sm ${textColor}`}>
            {getText(log, {}, true, eventTypes)}
          </div>
        </div>
        {
          isAlert ?
            <Badge text="Alerte" type="red" />
            :
            <Badge text="Conforme" type="green" />
        }
      </div>

    </div>
  ), [log, eventTypes]);
};
